import React from "react";
import { IAuthProvider } from "./AuthProvider";

export const AuthContext = React.createContext<IAuthProvider | null>(null);
